import Slideshow from './slideshow';

const Menu = {
  init: () => {
    Menu.menuOpen = false;
    Menu.menuButtons = document.querySelectorAll('.js-menuButton');
    Menu.hamburger = document.querySelector('.js-hamburger');
    Menu.sidebar = document.querySelector('.js-sidebar');
    Menu.main = document.querySelector('.js-main');
    Menu.menuButtons.forEach(button => {
      button.addEventListener('click', function(e) {
        clearTimeout(Menu.closeTime);
        Menu.close(button);
        e.stopImmediatePropagation();
      })
    })
  },
  close: (button = false) => {
    if (button && button.classList.contains('hamburger')) {
        Menu.sidebar.classList.add('sidebar--in');
        Menu.hamburger.classList.add('hamburger--hidden');
        Menu.main.classList.add('main--small');
        if (window.matchMedia("(max-width: 576px)").matches) {
            Menu.closeTime = setTimeout(function(){
                Menu.close()
            }, 4000);
        }
    } else {
        Menu.sidebar.classList.remove('sidebar--in');
        Menu.hamburger.classList.remove('hamburger--hidden');
        Menu.main.classList.remove('main--small');
    }
    Slideshow.resize();
  }
};

export default Menu;
